export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/gaming_videos.d91d8e5.svg";